import { useState } from "react"
import arrow from "./esalab/icons8-arrow-down-ios-17-outlined (1)/icons8-arrow-down-100.png"

export default function Footer(){

    const [info,setinfo] = useState();
    function formsubmit(event){
        event.preventDefault();
        console.log(info);
    }
    return <footer id="webfooter">
    <div class="footer_logo">
        <img src="data/images/AHK_LOGO_UPDATE-removebg-preview.png" alt="reload"/>
    </div>
    <div class="home_para">
        <div class="links">
            <h3>links</h3>
            <ul className="footerarrange">
                <li><a href="/">HOME</a></li>
                <li><a href="/about">ABOUT US</a></li>
                <li><a href="/contact">CONTACT US</a></li>
            </ul>
        </div>
        <div class="contacts">
            <h3>Contact details</h3>
            <ul className="footerarrange">
                <li><span class="material-symbols-outlined">
                    CONTACT:
                    </span>
                    <a href="tel:03232195385">+92 323-2195385</a>
                </li>
                <li className="fixpr">
                    <a href="tel:03333382302">+92 333-3382302</a></li>
                <li>
                    <span class="material-symbols-outlined">
                        MAIL:
                    </span>
                    <a href="mailto:ahkportablexray@gmail.com">ahkportablexray@gmail.com</a>
                </li>
                <li>
                    <span class="material-symbols-outlined">
                        ADDRESS:
                    </span>
                <a href="https://maps.app.goo.gl/nMhwwcztjjtztBLGA">S 1/10 Majeed Colony Sector II, Majeed Colony 1 Landhi Town Sector, Karachi, ll, Sindh 75120</a>
            </li>
            </ul>
        </div>
        <div class="location">
            <h3>LOCATION</h3>
            <div class="html_location">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14483.23433034392!2d67.2370514!3d24.8362189!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb3319b2b25ac13%3A0x7b5d84aba97585f8!2sAHK%20portable%20X-RAY%20Service!5e0!3m2!1sen!2s!4v1721623939508!5m2!1sen!2s" width="1000" height="500" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div> 
    </div>
    <br/>
    <br/>
    <br/>
    <br/>
    <hr/>
    <br/>
    {/* <div class="copyright">
        <p>© 2024 AHK Portable X-Ray Service. All rights reserved. Designed & Developed by Saadi tech</p>
    </div> */}


</footer>
}